import { createContext } from 'react';

import { PeerTypes } from '../../../../api';

interface PeerContextValue {
  peerType?: PeerTypes;
  prizeType?: 'team' | 'participant';
}

export const PeerContext = createContext<PeerContextValue | null>(null);
export const PeerProvider = PeerContext.Provider;
